import { Directive, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import { ActionConfirmComponent } from "../../components/ui/actionconfirm/actionconfirm.component";
import { MultipleLoadingViewComponent } from "../../components/ui/multiple-loading-view/multiple-loading-view.component";
import { ActionConfirmModel } from "../../models/action-confirm.model";
import { DIALOG_LARGE_CONFIG, DIALOG_MEDIUM_CONFIG } from "../../utils/config/modal-settings";
import { FALSE, TRUE } from "../../utils/config/const";



/**
 * Estende le classi con template table in modo da aggiungere le funzionalità in comune come 
 * le checkbox
 */
@Directive()
export class PageTemplateTable {

    private DIMPAGE_default: number = 10;
    private NUMEROPAGINA_default: number = 0;
    public dimPagina: number = this.DIMPAGE_default;
    public numeroPagina: number = this.NUMEROPAGINA_default;

    public statusCheckAll: boolean = false;
    public totalChecked: number = 0;

    @ViewChild(DataTableDirective, { static: false })
    public dtElement: DataTableDirective;
    public dtInstance: DataTables.Api;
    public dtOptions: DataTables.Settings = {};
    public dtTrigger: Subject<any> = new Subject<any>();

    public entityList: any = [];
    public lengthMenu: any = [{ "value": 10 }, { "value": 25 }, { "value": 50 }, { "value": 100 }];
    public defaultLength: any = [{ "value": 10 }];
    public settings: any = {
        singleSelection: true,
        enableCheckAll: false,
        enableFilterSelectAll: false,
        enableSearchFilter: false,
        searchBy: ['value'],
        classes: 'form-control topic-select small',
        showCheckbox: false,
        searchAutofocus: false,
        lazyLoading: false,
        labelKey: 'value',
        primaryKey: 'value',
        autoPosition: false,
        maxHeight: 200,
        scrollX: true,
    };




    constructor(
        protected modalService?: NgbModal
    ) { }


    setDIMPAGE_default(val) { this.DIMPAGE_default = val; }
    setNUMEROPAGINA_default(val) { this.NUMEROPAGINA_default = val; }


    /*  Gestione Checkbox */
    toggleCheckAll() {
        this.statusCheckAll = !this.statusCheckAll;
    }
    onCheckAll() {
        this.toggleCheckAll();
        this.onSetCheckTable(this.statusCheckAll);
        this.countTotalChecked();
    }
    onCheckRow(id) {
        this.entityList.forEach((item, i,) => {
            if (id === item.id) {
                this.entityList[i].checked = !this.entityList[i].checked;
            }
        });
        this.countTotalChecked();
    }
    onSetCheckTable(value) {
        this.entityList.forEach((item, i,) => {
            this.entityList[i].checked = value;
        });
    }
    resetTotalChecked() {
        this.statusCheckAll = false;
        this.totalChecked = 0;
    }
    onCancelSelected() {
        this.statusCheckAll = false;
        this.onSetCheckTable(this.statusCheckAll);
        this.totalChecked = 0;
    }
    countTotalChecked() {
        this.totalChecked = 0;
        this.entityList.forEach((item, i,) => {
            if (item.checked === TRUE) {
                this.totalChecked = this.totalChecked + 1;
            }
        });
        if (this.totalChecked == 0) {
            this.resetTotalChecked();
        }
    }
    //Controllo se almeno una checkbox è selezionata
    isCheckedAtLeastOne() {
        return (this.totalChecked > 0 ? true : false);
    }
    //Restituisce la liste di oggetti delle righe selezionate
    getListChecked() {
        let listChecked = [];
        this.entityList.forEach((item, i,) => {
            if (item.checked === TRUE) {
                listChecked.push(item);
            }
        });
        return listChecked;
    }
    /*  Fine Gestione Checkbox */


    /*  Gestione Modifica di massa */

    /**
     * Feedback all'utente se non ha selezionato nessuna riga per le modifiche di massa
     * */
    onClickControllItemMassModify() {
        let res = this.isCheckedAtLeastOne();
        if (res === FALSE) {
            const modalRef = this.modalService.open(ActionConfirmComponent, DIALOG_MEDIUM_CONFIG);
            modalRef.componentInstance.actionTemplate = new ActionConfirmModel();
            modalRef.componentInstance.actionTemplate.title = "Selezione";
            modalRef.componentInstance.actionTemplate.body = "Seleziona almeno un elemento per le modifiche di massa";
            modalRef.componentInstance.actionTemplate.textButtonConfirm = "OK";
            modalRef.componentInstance.actionTemplate.buttonCancelVisible = false
            modalRef.result.then(result => {
                if (result) {
                    console.log(result);
                }
            });
        }
        return res;
    }

    //Apre modale per feedback visivo dei risultati delle chiamate
    openMultiLoadingView(obj: any, refreshTable?: any) {
        const modalRef = this.modalService.open(MultipleLoadingViewComponent, DIALOG_LARGE_CONFIG);
        modalRef.componentInstance.callList = obj;
        modalRef.result.then(result => {
            if (result) {

                //Pulisco le checkbox
                this.onCancelSelected();
                //Aggiorna tabella
                if (typeof refreshTable === typeof undefined || refreshTable === TRUE) {
                    this.ajaxReload();
                }

            }
        }, (error) => {
            console.log(error);
            //Pulisco le checkbox
            this.onCancelSelected();
            //Aggiorna tabella
            this.ajaxReload();
        });
    }
    /*  Fine Gestione Modifica di massa */




    //Inizializza dtOptions
    initCommon_dtOptions() {
        this.dtOptions = {
            deferRender: true,
            order: [[1, "desc"]],
            paging: true,
            pageLength: this.dimPagina,
            pagingType: "simple_numbers",
            searching: false,
            lengthChange: false,
            serverSide: true,
            processing: true,
            responsive: true,
            language: {
                info: "_END_/_TOTAL_ Elementi visualizzati",
                infoEmpty: "0 di 0 Elementi",
                paginate: {
                    previous: '<i class="far fa fa-arrow-left pe-4"></i>',
                    next: '<i class="far fa fa-arrow-right ps-4"></i>',
                    last: '',
                    first: ''
                }
            },
            dom: 't<"row mt-4"<"col d-flex"i<"pagination-position"p>>>'
        };
    }







    /**
     * Rirenderizza la tabella ricaricando i risultati
     */
    ajaxReload(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.ajax.reload();
        });
    }

    trigger(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next();
        });
    }




    /**
     * Reset di tutti i filtri relativi alla tabella
     */
    public resetFilter() {
        this.resetTotalChecked();
        this.entityList = [];
        this.numeroPagina = this.NUMEROPAGINA_default;
    }

    public changeLength(length, numeroPagina) {
        this.entityList = [];
        this.dimPagina = length;
        this.numeroPagina = numeroPagina;
    }

    public drawTable() {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
        });
    }


    /**
      * Setta le informazioni della response 
      * @param response 
      */
    setListEntityList(response) {
        if (response != null && typeof response != typeof undefined) {
            if (response.hasOwnProperty("data")) {
                this.entityList = [];
                for (let data of response.data) {
                    data.checked = false;
                    this.entityList.push(data)
                }
            }
        }
    }







}